import React, { useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { register as registerFunction } from '../../components/shared/auth/register'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

/**
 * @deprecated Only for test purposes, delete ASAP
 *
 * @return {*}
 * @constructor
 */
const Register = () => {
    const [t] = useTranslation()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [name, setName] = useState('')
    const [surname, setSurname] = useState('')

    const authError = useSelector(state => state.auth.error)
    const busy = useSelector(state => state.auth.busy)

    const submitForm = event => {
        event.preventDefault()

        registerFunction(email, password, { name, surname })
    }

    return (
        <form onSubmit={submitForm}>
            <h2>Registrace</h2>

            <div className="mb-3 form-floating">
                <input
                    type="email"
                    className="form-control"
                    id="email-input"
                    value={email}
                    onChange={({ target }) => setEmail(target.value)}
                    placeholder={t('login.email')}
                />
                <label htmlFor="email-input">
                    {t('login.email')}
                </label>
            </div>
            <div className="mb-3 form-floating">
                <input
                    type="password"
                    className="form-control"
                    id="password-input"
                    value={password}
                    onChange={({ target }) => setPassword(target.value)}
                    placeholder={t('login.password')}
                />
                <label htmlFor="password-input">
                    {t('login.password')}
                </label>
            </div>

            <div className="mb-3 form-floating">
                <input
                    type="text"
                    className="form-control"
                    id="name-input"
                    value={name}
                    onChange={({ target }) => setName(target.value)}
                    placeholder="Jméno"
                />
                <label htmlFor="name-input">
                    Jméno
                </label>
            </div>

            <div className="mb-3 form-floating">
                <input
                    type="text"
                    className="form-control"
                    id="surname-input"
                    value={surname}
                    onChange={({ target }) => setSurname(target.value)}
                    placeholder="Příjmení"
                />
                <label htmlFor="surname-input">
                    Příjmení
                </label>
            </div>

            {authError && (
                <div className="text-danger">
                    {t(authError)}
                </div>
            )}

            <button
                type="submit"
                className={classNames({
                    'btn btn-primary': true,
                    'disabled': busy,
                })}
            >
                {busy && <i className="fa fa-spinner fa-spin" />}
                {!busy && t('login.submit')}
            </button>
        </form>
    )
}

export default Register
